import { gql } from '@apollo/client'

export const MEDIA_SIGNED_URL_QUERY = gql`
    query MediaSignedUrl($selfUrl: String!) {
        mediaSignedUrl(selfUrl: $selfUrl)
    }
`
